/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from "axios";
import React, { useEffect, useState } from "react";
import Games from "./components/Games";
import Categories from "./components/Categories";
import Search from "./components/Search";
import { createRequestJSON, getGameIframe, getGameUrl } from "./helpers/helpers";
import { IGame, GamesCollection, IGamesRequest, Provider } from "./interfaces/intefaces";
import { GamesEndpointUrl, CategoriesEndpointUrl, ProvidersEndpointUrl, perPage } from "./config/consts";
import './styles/slick.css';
import './styles/slick-theme.css';
import './styles/app.scss';
import NewGames from "./components/NewGames";
import HotGames from "./components/HotGames";
import AllGames from "./components/AllGames";
import GameModal from "./components/GameModal";
import ProvidersGrid from "./components/ProvidersGrid";
import ProvidersDropdown from "./components/ProvidersDropdown";
import FiltersSelected from "./components/FiltersSelected";

declare var activeCategoryType: any;
declare var config: any;

function App() {
  const [userIsLoggedIn, setUserIsLoggedIn] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [categories, setCategories] = useState([]);
  const [providers, setProviders] = useState<Provider[]>([]);
  const [games, setGames] = useState(undefined);
  const [gamesHot, setGamesHot] = useState(undefined);
  const [gamesNew, setGamesNew] = useState(undefined);

  const [activeCategory, setActiveCategory] = useState(-2);
  const [activeProvider, setActiveProvider] = useState<number[]>([]);
  const [searchString, setSearchString] = useState("");
  const [categoryType, setCategoryType] = useState(1);
  const [error, setError] = useState({ message: null });
  const [hotGames, setHotGames] = useState(0);
  const [newGames, setNewGames] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [gridView, setGridView] = useState(false);
  const [nameFilter, setNameFilter] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [gameIframe, setGameIframe] = useState("")
  const [showProviders, setShowProviders] = useState(false)
  const params: IGamesRequest = {
    category_id: activeCategory,
    categoryType: activeCategoryType,
    mobile: 1,
    forfun: undefined,
    lang: undefined,
    ct: 0,
    hot: hotGames,
    new: newGames,
    nc: 1,
    cp: currentPage,
    ps: perPage,
    prs: activeProvider,
    nf: nameFilter
  }

  const categoryHandler = (category_id: number, hotGame: number, newGame: number) => {
    if (category_id == -2) {
      setActiveCategory(-2);
      setActiveProvider([])
      setHotGames(hotGame);
      setNewGames(newGame);
      setGridView(false);
    
    } else {
      setActiveCategory(category_id);
      setHotGames(hotGame);
      setNewGames(newGame);
      setGridView(true)
    }
    setShowProviders(false)
  };
  const providerHandler = (prs: number[]) => {
    setActiveProvider(prs);
    setGridView(true);
  }

  const getOptionsForProviders = (selected: boolean): Array<{ value: number; label: string }> => {
    if (selected) {
      if (activeProvider.length ) {
        const filtered = providers.filter(option => (activeProvider.includes(option.id)));
        const options = filtered.map(option => ({
          value: option.id,
          label: option.name,
        }));
        return options
      } else {
        return []
      }

    } else {
      
      const options = providers.map(option => ({
        value: option.id,
        label: option.name,
      }));
      
      return options
    }
  }

  const removeFilter = (provider_id: number) => {
    const filtered = activeProvider.filter(option => (option !== provider_id));

    setActiveProvider(filtered)
    console.log(`remove ${provider_id}`)
  }

  const handleProviderGrid = (prs: number[]) => {
    setActiveProvider(prs)
    setActiveCategory(-1)
    setShowProviders(false)
    setGridView(true)

  }

  const searchHandler = (q: string) => {
    setSearchString(q);
    setGridView(true);
  }
  const openModal = (game: IGame, for_fun = false) => {
    if (config.enable_modal) {
      setGameIframe(getGameIframe(game, userIsLoggedIn, for_fun))
      setIsModalOpen(true);
    } else {
      window.location.href = getGameUrl(game);
    }

  };

  const closeModal = () => {
    setGameIframe("")
    setIsModalOpen(false);
  };

  const receiveMessage = (e: any) => {
    if (typeof e.data === 'string' && e.data.includes('UserState')) {
      const userUsername = JSON.parse(e.data).data.userUsername;
      if (userUsername !== null) {
        setUserIsLoggedIn(true);
      } else {
        setUserIsLoggedIn(false);

      }

    }
  }

  const dataToSubmit = createRequestJSON(params);
  var gamesArr = [];
  useEffect(() => {
    const fetchCategories = async (callback: any, errorCallback: any) => {
      const url = CategoriesEndpointUrl;
      const returnedData = await axios.get(
        url,
        { params: { categoryType: params.categoryType } }
      )
        .then(res => res.data.data)
        .catch(error => errorCallback(error.toJSON()));
      callback(returnedData);
    };
    fetchCategories(setCategories, setError);

    const fetchProviders = async (callback: any, errorCallback: any) => {
      const url = ProvidersEndpointUrl;
      const returnedData = await axios.get(
        url,
        {
          params: { categoryType: params.categoryType }
        })
        .then(res => res.data.data)
        .catch(error => errorCallback(error.toJSON()));
      callback(returnedData);
    };
    fetchProviders(setProviders, setError);


    window.addEventListener("message", receiveMessage, false);

  }, []);

  useEffect(() => {
    const fetchGames = async (callback: any, errorCallback: any) => {
      const url = GamesEndpointUrl;
      const returnedData = await axios.get(
        url,
        { params: dataToSubmit }
      )
        .then(res => res.data.data)
        .catch(error => errorCallback(error.toJSON()));
      callback(returnedData);
      setLoaded(true);

    };
    setLoaded(false);
    setCurrentPage(1);
    fetchGames(setGames, setError);

  }, [activeCategory, categoryType, activeProvider, hotGames, newGames, nameFilter]);

  useEffect(() => {
    if (searchString.length === 0) {
      setNameFilter("")
      return void 1;
    }
    else {
      if (searchString.length > 2) {
        const interval = setInterval(() => setNameFilter(searchString), 800);
        return () => {
          clearInterval(interval);
        };
      } else {
        return void 1;
      }
    }

  }, [searchString]);

  useEffect(() => {

    const fetchGamesHot = async (callback: any, errorCallback: any) => {
      const url = GamesEndpointUrl;
      const returnedData = await axios.get(url, { params: { nc: 1, hot: 1, categoryType: params.categoryType } })
        .then(res => res.data.data)
        .catch(error => errorCallback(error.toJSON()));
      callback(returnedData);
    };
    fetchGamesHot(setGamesHot, setError);

    const fetchGamesNew = async (callback: any, errorCallback: any) => {
      const url = GamesEndpointUrl;
      const returnedData = await axios.get(url, { params: { nc: 1, new: 1, categoryType: params.categoryType } })
        .then(res => res.data.data)
        .catch(error => errorCallback(error.toJSON()));
      callback(returnedData);
    };
    fetchGamesNew(setGamesNew, setError);


  }, []);

  let gamesCollection: GamesCollection = { count: 0, games: [] }
  if (games) {
    gamesArr = (games as any).games.slice(0, (currentPage + 1) * perPage);
    gamesCollection = { count: (games as any).count, games: gamesArr }
  }

  return (
    <>
      {(error.message !== null) &&
        <div>{error.message}</div>
      }
      <div className="container-fw">
        <div className="games_filter-wrap">
          <div className="col-left">
            <Search searchString={searchString} setSearchString={searchHandler} />
            <Categories
              categories={categories}
              activeCategory={activeCategory}
              updateCategory={categoryHandler}
              setCategoryType={setCategoryType}
              hotGames={hotGames}
              newGames={newGames}
            />
            <div className={showProviders ? "all-providers active" : "all-providers"} onClick={(e) => { setShowProviders(!showProviders) }}><div><i className={`icon icon-providers`}></i><span>ALL PROVIDERS</span></div></div>

          </div>
          <div className="col-right">
            <div className="games-wrap">
              {showProviders && (
                <ProvidersGrid providers={providers} handleProviderGrid={handleProviderGrid} />
              )}

              {(gridView === false && !showProviders) && (
                <>
                  <NewGames
                    games={gamesNew}
                    updateCategory={categoryHandler}
                    userIsLoggedIn={userIsLoggedIn}
                    openModal={openModal}

                  />
                  <HotGames
                    games={gamesHot}
                    updateCategory={categoryHandler}
                    userIsLoggedIn={userIsLoggedIn}
                    openModal={openModal}


                  />
                  <AllGames
                    games={gamesCollection}
                    updateCategory={categoryHandler}
                    userIsLoggedIn={userIsLoggedIn}
                    openModal={openModal}
                  />
                </>
              )}
              {gridView && !showProviders && (
                <>
                <div className="filters">
                  <div className="filters-selected">
                    <FiltersSelected providers={providers} selectedProviders={activeProvider} removeFilter={removeFilter} />
                  </div>
                  <div className="providers-dropdown">
                    {providers.length > 0 && (<ProvidersDropdown options={getOptionsForProviders(false)} selectedValues={getOptionsForProviders(true)} onChange={providerHandler} />)}
                  </div>
                </div>                
                  <Games
                    games={gamesCollection}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    userIsLoggedIn={userIsLoggedIn}
                    openModal={openModal}
                  />
                </>
              )}
              <GameModal isOpen={isModalOpen} onRequestClose={closeModal}>
                <iframe id="gameloader" src={gameIframe} width="100%"></iframe>
              </GameModal>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default App;